import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/user-48.jpg'
import _imports_1 from '@/assets/images/user-49.jpg'
import _imports_2 from '@/assets/images/user-50.jpg'
import _imports_3 from '@/assets/images/user-51.jpg'
import _imports_4 from '@/assets/images/user-52.jpg'
import _imports_5 from '@/assets/images/user-53.jpg'
import _imports_6 from '@/assets/images/user-54.jpg'
import _imports_7 from '@/assets/images/user-55.jpg'
import _imports_8 from '@/assets/images/user-56.jpg'
import _imports_9 from '@/assets/images/user-57.jpg'
import _imports_10 from '@/assets/images/user-58.jpg'
import _imports_11 from '@/assets/images/user-59.jpg'
import _imports_12 from '@/assets/images/wordpress.png'
import _imports_13 from '@/assets/images/html.png'
import _imports_14 from '@/assets/images/question-and-answer.png'
import _imports_15 from '@/assets/images/social-media.png'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xxl-8 col-xl-7 col-lg-7 col-md-7" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center flex-wrap ga-2 border-bottom pb-4 mb-4" }
const _hoisted_6 = { class: "ps-0 mb-0 list-unstyled chat-call-option d-flex gap-1 gap-xl-3" }
const _hoisted_7 = { class: "p-0 border-0 bg-transparent" }
const _hoisted_8 = { class: "p-0 border-0 bg-transparent" }
const _hoisted_9 = { class: "dropdown action-opt" }
const _hoisted_10 = { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }
const _hoisted_11 = { class: "d-sm-flex justify-content-between align-items-center bg-gary-light for-dark rounded-3 p-4" }
const _hoisted_12 = { class: "d-flex gap-3 justify-content-center justify-content-sm-start" }
const _hoisted_13 = { class: "p-0 border-0 bg-transparent" }
const _hoisted_14 = { class: "p-0 border-0 bg-transparent" }
const _hoisted_15 = { class: "p-0 border-0 bg-transparent" }
const _hoisted_16 = { class: "p-0 border-0 bg-transparent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-xxl-4 col-xl-5 col-lg-5 col-md-5" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("h4", { class: "fw-medium fs-16 mb-0 mb-3" }, "Messages"),
            _createElementVNode("form", { class: "position-relative default-src-form" }, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control rounded-1",
                placeholder: "Search here"
              }),
              _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y fs-18" }, " search ")
            ])
          ]),
          _createElementVNode("ul", {
            class: "nav nav-tabs justify-content-between chat-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link p-0 border-0 fw-medium text-body rounded-0 pb-2 active",
                id: "all-message-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#all-message-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "all-message-tab-pane",
                "aria-selected": "true"
              }, " All Message ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link p-0 border-0 fw-medium text-body rounded-0 pb-2",
                id: "group-chat-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#group-chat-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "group-chat-tab-pane",
                "aria-selected": "false"
              }, " Group Chat ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link p-0 border-0 fw-medium text-body rounded-0 pb-2",
                id: "contacts-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#contacts-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "contacts-tab-pane",
                "aria-selected": "false"
              }, " Contacts ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "all-message-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "all-message-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "max-h-497 hover-scroll-bar" }, [
                _createElementVNode("span", { class: "mb-3 d-block fw-medium fs-12" }, [
                  _createElementVNode("i", { class: "ri-pushpin-line fs-14 me-1" }),
                  _createElementVNode("span", { class: "ms-1" }, "PINNED")
                ]),
                _createElementVNode("ul", { class: "ps-0 mb-4 list-unstyled chat-list" }, [
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Sarah Smith"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Hello every one. Are you reday for meetig ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "Just Now"),
                      _createElementVNode("span", { class: "fs-12 fw-medium bg-primary text-white rounded-circle wh-16 lh-16 d-inline-block text-center" }, " 2 ")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom border-color-gray pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "wh-48 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Michael Johnson"),
                        _createElementVNode("span", { class: "text-success" }, "Typing...")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "10:20 AM"),
                      _createElementVNode("i", { class: "ri-check-double-line fs-16 text-primary" })
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_2,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-warning border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Sarah Smith"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Voice message... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "9:30 AM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_3,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "David Martinez"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Excellent work... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "3:20 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "David Martinez"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Excellent work... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "3:20 PM"),
                      _createElementVNode("span", { class: "fs-12 fw-medium bg-primary text-white rounded-circle wh-16 lh-16 d-inline-block text-center" }, " 5 ")
                    ])
                  ])
                ]),
                _createElementVNode("span", { class: "mb-3 d-block fw-medium fs-12" }, [
                  _createElementVNode("i", { class: "ri-chat-poll-line fs-16" }),
                  _createElementVNode("span", { class: "ms-1" }, "ALL MESSAGE")
                ]),
                _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled chat-list" }, [
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_5,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Jessica Taylor"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Hello Mr.. ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "12:00 AM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Christopher Lee"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Very good... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "8:30 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_7,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Amanda Rodriguez"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " That’s cool... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "2:20 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_8,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Daniel Garcia"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Good morning ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "10:00 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_9,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Jennifer Thomas"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Hi John ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "11:10 AM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_10,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Elizabeth Clark"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Sounds good... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "12:30 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_11,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "William Lewis"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " How are you? ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "11:20 AM")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "group-chat-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "group-chat-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "max-h-497 hover-scroll-bar" }, [
                _createElementVNode("span", { class: "mb-3 d-block fw-medium fs-12" }, [
                  _createElementVNode("i", { class: "ri-pushpin-line fs-14 me-1" }),
                  _createElementVNode("span", { class: "ms-1" }, "PINNED")
                ]),
                _createElementVNode("ul", { class: "ps-0 mb-4 list-unstyled chat-list" }, [
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_12,
                          class: "wh-45 rounded-circle",
                          alt: "wordpress"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Wordpress"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, "Hello every one. Are you reday for meetig")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "Just Now"),
                      _createElementVNode("span", { class: "fs-12 fw-medium bg-primary text-white rounded-circle wh-16 lh-16 d-inline-block text-center" }, " 2 ")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom border-color-gray pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_13,
                          class: "wh-48 rounded-circle",
                          alt: "html"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "HTML"),
                        _createElementVNode("span", { class: "text-success" }, "Typing...")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "10:20 AM"),
                      _createElementVNode("i", { class: "ri-check-double-line fs-16 text-primary" })
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_14,
                          class: "wh-45 rounded-circle",
                          alt: "question-and-answer"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-warning border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "QA TEST"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Voice message... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "9:30 AM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_15,
                          class: "wh-45 rounded-circle",
                          alt: "social-media"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, " Digital Marketing "),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Excellent work... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "3:20 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Team David"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Excellent work... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "3:20 PM"),
                      _createElementVNode("span", { class: "fs-12 fw-medium bg-primary text-white rounded-circle wh-16 lh-16 d-inline-block text-center" }, " 5 ")
                    ])
                  ])
                ]),
                _createElementVNode("span", { class: "mb-3 d-block fw-medium fs-12" }, [
                  _createElementVNode("i", { class: "ri-chat-poll-line fs-16" }),
                  _createElementVNode("span", { class: "ms-1" }, "ALL MESSAGE")
                ]),
                _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled chat-list" }, [
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_5,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Jessica Taylor"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Hello Mr.. ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "12:00 AM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Christopher Lee"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Very good... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "8:30 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_7,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Amanda Rodriguez"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " That’s cool... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "2:20 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_8,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Daniel Garcia"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Good morning ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "10:00 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_9,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Jennifer Thomas"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Hi John ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "11:10 AM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_10,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Elizabeth Clark"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Sounds good... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "12:30 PM")
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_11,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "William Lewis"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " How are you? ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12" }, "11:20 AM")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "contacts-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "contacts-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "max-h-497 hover-scroll-bar" }, [
                _createElementVNode("span", { class: "mb-3 d-block fw-medium fs-12" }, [
                  _createElementVNode("i", { class: "ri-pushpin-line fs-14 me-1" }),
                  _createElementVNode("span", { class: "ms-1" }, "PINNED")
                ]),
                _createElementVNode("ul", { class: "ps-0 mb-4 list-unstyled chat-list" }, [
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Sarah Smith"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate text-danger",
                          style: {"max-width":"150px"}
                        }, " Missed Call ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "Just Now"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom border-color-gray pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "wh-48 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Michael Johnson"),
                        _createElementVNode("span", { class: "text-success" }, "Received Call")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "10:20 AM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_2,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-warning border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Sarah Smith"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Voice message... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "9:30 AM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_3,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "David Martinez"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate text-success",
                          style: {"max-width":"150px"}
                        }, " Received Call ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "3:20 PM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "David Martinez"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate text-success",
                          style: {"max-width":"150px"}
                        }, " Received Call ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "3:20 PM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("span", { class: "mb-3 d-block fw-medium fs-12" }, [
                  _createElementVNode("i", { class: "ri-chat-poll-line fs-16" }),
                  _createElementVNode("span", { class: "ms-1" }, "ALL MESSAGE")
                ]),
                _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled chat-list" }, [
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_5,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Jessica Taylor"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Hello Mr.. ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "12:00 AM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Christopher Lee"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Very good... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "8:30 PM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_7,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Amanda Rodriguez"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " That’s cool... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "2:20 PM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_8,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Daniel Garcia"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Good morning ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "10:00 PM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_9,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Jennifer Thomas"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Hi John ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "11:10 AM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_10,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Elizabeth Clark"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " Sounds good... ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "12:30 PM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", { class: "d-flex justify-content-between align-items-center cursor" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                        _createElementVNode("img", {
                          src: _imports_11,
                          class: "wh-45 rounded-circle",
                          alt: "user"
                        }),
                        _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2 ps-1 position-relative top-2" }, [
                        _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "William Lewis"),
                        _createElementVNode("span", {
                          class: "d-inline-block text-truncate",
                          style: {"max-width":"150px"}
                        }, " How are you? ")
                      ])
                    ]),
                    _createElementVNode("div", { class: "text-end" }, [
                      _createElementVNode("span", { class: "d-block fs-12 mb-1" }, "11:20 AM"),
                      _createElementVNode("div", { class: "d-flex gap-1 justify-content-between" }, [
                        _createElementVNode("i", { class: "ri-phone-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" }),
                        _createElementVNode("i", { class: "ri-vidicon-fill fs-14 text-primary wh-25 lh-25 bg-primary rounded-1 bg-opacity-10 text-center hover-bg" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0 position-relative\"><img src=\"" + _imports_1 + "\" class=\"wh-52 rounded-circle\" alt=\"user\"><div class=\"position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2\"></div></div><div class=\"flex-grow-1 ms-2 ps-1 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Michael Johnson</h4><span>Active now</span></div></div>", 1)),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_7, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "ri-phone-line fs-16 text-body hover" }, null, -1)
                ]))])), [
                  [
                    _directive_b_tooltip,
                    'Audio_Call',
                    void 0,
                    {
                      hover: true,
                      top: true
                    }
                  ]
                ])
              ]),
              _createElementVNode("li", null, [
                _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_8, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "ri-vidicon-fill fs-16 text-body hover" }, null, -1)
                ]))])), [
                  [
                    _directive_b_tooltip,
                    'Video_Call',
                    void 0,
                    {
                      hover: true,
                      top: true
                    }
                  ]
                ])
              ]),
              _createElementVNode("li", null, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[5] || (_cache[5] = _createElementVNode("button", {
                    class: "p-0 border-0 bg-transparent",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, [
                    _createElementVNode("i", { class: "ri-more-2-fill fs-16 text-body hover" })
                  ], -1)),
                  _createElementVNode("ul", _hoisted_10, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        class: "dropdown-item",
                        to: "/my-profile"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("i", { "data-feather": "eye" }, null, -1),
                          _createTextVNode(" View Profile ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:;"
                      }, [
                        _createElementVNode("i", { "data-feather": "trash-2" }),
                        _createTextVNode(" Delete Chat ")
                      ])
                    ], -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:;"
                      }, [
                        _createElementVNode("i", { "data-feather": "lock" }),
                        _createTextVNode(" Block ")
                      ])
                    ], -1))
                  ])
                ])), [
                  [
                    _directive_b_tooltip,
                    'More_Option',
                    void 0,
                    {
                      hover: true,
                      top: true
                    }
                  ]
                ])
              ])
            ])
          ]),
          _cache[12] || (_cache[12] = _createStaticVNode("<span class=\"d-block fs-12 mb-2\">2023-11-10 09:15 AM</span><ul class=\"mb-0 list-unstyled chat-details max-h-419 hover-scroll-bar\"><li class=\"mb-4\"><div class=\"d-sm-flex\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"wh-48 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-sm-3 mt-3 mt-sm-0\"><div class=\"d-flex align-items-center\"><p> Hey Micheals, have you had a chance to check out the new admin dashboard? </p><div class=\"dropdown action-opt ms-2\"><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"ri-more-2-fill text-secondary\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"corner-up-right\"></i> Reply </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete You </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete Everyone </a></li></ul></div></div><span class=\"fs-12 d-block\">19:04 PM</span></div></div></li><li class=\"mb-4 ms-auto own-chat\"><div class=\"d-sm-flex text-end\"><div class=\"flex-grow-1 mb-3 mb-sm-0\"><div class=\"d-flex align-items-center justify-content-end\"><div class=\"dropdown action-opt me-2\"><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"ri-more-2-fill text-secondary\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"corner-up-right\"></i> Reply </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete You </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete Everyone </a></li></ul></div><p>Oh, you mean the one for project management?</p></div><span class=\"fs-12 d-block\">09:20 AM</span></div></div></li><li class=\"mb-4\"><div class=\"d-sm-flex\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"wh-48 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-sm-3 mt-3 mt-sm-0\"><div class=\"d-flex align-items-center\"><p> Yeah, that&#39;s the one It&#39;s got a sleek Material Design, and the features are pretty robust. </p><div class=\"dropdown action-opt ms-2\"><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"ri-more-2-fill text-secondary\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"corner-up-right\"></i> Reply </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete You </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete Everyone </a></li></ul></div></div><span class=\"fs-12 d-block\">09:20 AM</span></div></div></li><li class=\"mb-4 ms-auto own-chat\"><div class=\"d-sm-flex text-end\"><div class=\"flex-grow-1 mb-3 mb-sm-0\"><div class=\"d-flex align-items-center justify-content-end\"><div class=\"dropdown action-opt me-2\"><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"ri-more-2-fill text-secondary\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"corner-up-right\"></i> Reply </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete You </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete Everyone </a></li></ul></div><p>Nice What features are you finding interesting?</p></div><span class=\"fs-12 d-block\">09:21 AM</span></div></div></li><li class=\"mb-4\"><div class=\"d-sm-flex\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"wh-48 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-sm-3 mt-3 mt-sm-0\"><div class=\"d-flex align-items-center\"><p> Well, it has a project overview with all the key metrics on the landing page – project </p><div class=\"dropdown action-opt ms-2\"><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"ri-more-2-fill text-secondary\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"corner-up-right\"></i> Reply </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete You </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete Everyone </a></li></ul></div></div><span class=\"fs-12 d-block\">09:22 AM</span></div></div></li><li class=\"mb-4 ms-auto own-chat\"><div class=\"d-sm-flex text-end\"><div class=\"flex-grow-1 mb-3 mb-sm-0\"><div class=\"d-flex align-items-center justify-content-end\"><div class=\"dropdown action-opt me-2\"><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"ri-more-2-fill text-secondary\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"corner-up-right\"></i> Reply </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete You </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete Everyone </a></li></ul></div><p> That sounds handy. How about the task management features? </p></div><span class=\"fs-12 d-block\">09:21 AM</span></div></div></li><li class=\"mb-4\"><div class=\"d-sm-flex\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"wh-48 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-sm-3 mt-3 mt-sm-0\"><div class=\"d-flex align-items-center\"><p> Oh, they&#39;ve got this Kanban board for task management. You can drag and drop tasks between columns – it&#39;s so intuitive. </p><div class=\"dropdown action-opt ms-2\"><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"ri-more-2-fill text-secondary\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"corner-up-right\"></i> Reply </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete You </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete Everyone </a></li></ul></div></div><span class=\"fs-12 d-block\">09:30 AM</span></div></div></li><li class=\"mb-4 ms-auto own-chat\"><div class=\"d-sm-flex text-end\"><div class=\"flex-grow-1 mb-3 mb-sm-0\"><div class=\"d-flex align-items-center justify-content-end\"><div class=\"dropdown action-opt me-2\"><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"ri-more-2-fill text-secondary\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"corner-up-right\"></i> Reply </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete You </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete Everyone </a></li></ul></div><p>Sweet What about team collaboration?</p></div><span class=\"fs-12 d-block\">09:31AM</span></div></div></li></ul>", 2)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_13, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "ri-emotion-laugh-line fs-18 text-body" }, null, -1)
              ]))])), [
                [
                  _directive_b_tooltip,
                  'Emoji',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_14, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "ri-link-m fs-18 text-body" }, null, -1)
              ]))])), [
                [
                  _directive_b_tooltip,
                  'Link',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_15, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "ri-mic-line fs-18 text-body" }, null, -1)
              ]))])), [
                [
                  _directive_b_tooltip,
                  'Voice',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_16, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "ri-image-line fs-18 text-body" }, null, -1)
              ]))])), [
                [
                  _directive_b_tooltip,
                  'Image',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ])
            ]),
            _cache[11] || (_cache[11] = _createStaticVNode("<form action=\"\" class=\"w-100 ps-sm-4 ps-xxl-4 ms-xxl-3 mt-3 mt-sm-0 position-relative\"><input type=\"text\" class=\"form-control rounded-1 border-0 text-dark h-55\" placeholder=\"Type your message\"><button class=\"p-0 border-0 bg-transparent position-absolute top-50 end-0 translate-middle-y pe-3 d-sm-none\"><i class=\"material-symbols-outlined fs-24 text-primary\">send</i></button></form><button class=\"p-0 border-0 bg-primary d-none d-sm-block rounded-1 ms-3\"><i class=\"material-symbols-outlined fs-24 text-white wh-55 lh-55 d-inline-block\"> send </i></button>", 2))
          ])
        ])
      ])
    ])
  ]))
}